<section class="container">
  <div class="content-block">
    <app-recharge-record [invoices]="invoices" [showAll]="true" [isLoading]="isLoading"></app-recharge-record>
    <div *ngIf="isLoading" class="loading-indicator">
      <div class="spinner"></div>
      <span>{{ 'Common.Loading.text' | translate }}</span>
    </div>
    <div *ngIf="isAllLoaded && invoices.length > 0" class="loading-indicator">
      <span>{{ 'Common.Loading.allLoaded' | translate }}</span>
    </div>
  </div>
</section>